var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-slider-container"},[_c('div',{staticClass:"progress-bar"},[_vm._l((_vm.segments),function(seg,index){return _c('div',{key:index,staticClass:"segment",style:({
            width: `${seg.width}%`,
            backgroundColor: seg.color,
            left: `${seg.left}%`
        })})}),_c('div',{staticClass:"slider-dot",style:({ left: `${(_vm.value / _vm.max) * 100}%` })})],2),_c('div',{staticClass:"ticks"},_vm._l((_vm.segments),function(seg,index){return _c('span',{key:index,staticClass:"tick"},[_vm._v("\n            "+_vm._s(seg.label)+"\n        ")])}),0),_c('div',{staticClass:"value-display"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }